import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { reactFormatter } from "react-tabulator";
import MainTemplate from "../../custom_components/templates/MainTemplate.js";
import {
  TabulatorTemplate,
  FullTabulatorTemplate,
} from "custom_components/templates/TabulatorTemplate.js";
import DoApplicationCreate from "pages/finance/DoApplicationCreate.js";
import DoFilePreview from "pages/finance/DoFilePreview.js";
import DoApplicationInfo from "pages/finance/DoApplicationInfo.js";
import {
  useFetchPost,
  useUserPermission,
  sessionSetLoading,
} from "../../custom_hooks/Actions.js";
import { flipTrueFalse } from "helper_functions/Helper.js";
import Swal from "sweetalert2";

const path = process.env.REACT_APP_PATH;
const domain = process.env.REACT_APP_DOMAIN

function parseDoApplication(data) {
  let dataForActive = [];
  let dataForInactive = [];
  try {
    for (let i = 0; i < data.length - 1; i++) {
      data[i].forEach((number, index, array) => {
        const obj = {
          no: index + 1,
          id: array[index]["DOID"],
          supplierName : array[index]["SupplierName"],
          doDate : array[index]["DoDate"],
          poNumber: array[index]["PoNumber"],
          projectCode: array[index]["ProjectCode"],
          doNumber: array[index]["DoNumber"],
          status:array[index]["Status"],
          approvalStatus:array[index]["ApprovalStatus"],
          viewFile: array[index]['FileStatus'],
          fileName: array[index]['MergedFilename'],
          // pendingCount: array[index]["PendingCount"],
          action: [],
        };
        if (i === 0) {
          if (data[i][0] !== 0) {
            dataForActive.push(obj);
          }
        } else {
          if (data[i][0] !== 0) {
            dataForInactive.push(obj);
          }
        }
      });
    }
  } catch {
    return ["", ""];
  }
  const parsedData = [dataForActive, dataForInactive];
  return parsedData;
}

function getRole(data) {
  const role = data;
  console.log(role);
  return role;
}

function DoApplication({ permission }) {
  let location = useLocation();
  const [refetch, setRefetch] = useState(0);

  // window.location.toString().split(path)[0] + path +
  const doApplicationData = useFetchPost(
    domain + "/api/FinanceModule/DoApplication.php?action",
    {},
    refetch
  );

  const parsedData = parseDoApplication(doApplicationData.data);
  const roleData = getRole(doApplicationData.data[2]);
  const tabs = ["Active", "History"];
  const defaultTab = tabs[0];
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [redirect, setRedirect] = useState({ allow: false });
  const [HLID, setHLID] = useState("");
  const [status, setStatus] = useState("");
  const [role, setRole] = useState("");

  function handleRefetch() {
    setRefetch(Math.random())
  }

  function handleUserPasswordRedirect(e) {
    e.preventDefault();
    
  }

  const columns = [
    { title: "Sr/No.", field: "no", headerFilter: "input" },
    {
      title: "DO ID",
      field: "id",
      headerFilter: "input",
      formatter: "link",
      formatterParams: {
        labelField: "id",
        urlPrefix: "finance/scan-documents/",
      },
      //hacky way to make tabulator play well with react routers
      cellClick: function (e, cell) {
        e.preventDefault();
        const rowInfo = cell._cell.row.data;
        setRedirect({ allow: true, id: rowInfo.id, type: 'id' }); //here we update state
      },
    },
    { title: "PO Number", field: "poNumber", headerFilter: "input" },
    { title: "Supplier Name", field: "supplierName", headerFilter: "input" },
    { title: "DO Number", field: "doNumber", headerFilter: "input" },
    { title: "DO Date", field: "doDate", headerFilter: "input" },
    { title: "Project Code", field: "projectCode", headerFilter: "input" },
    { title: "Approval Status", field: "approvalStatus", headerFilter: "input" },
    { title: "File Status", field: "status", headerFilter: "input" },
    {
      title: "View File",
      field: "viewFile",
      headerFilter: "input",
      formatter: (cell) => {
        const value = cell.getValue();
        if(value == 'View File'){
          const fileUrl = cell.getRow().getData().fileUrl;
          return `<a href="$" target="_blank" rel="noopener noreferrer"> View File </a>`;
        }else{
          return value;
        }
      },
      formatterParams: {
        labelField: "viewFile",
        urlPrefix:   "/View",
      },
      //hacky way to make tabulator play well with react router
      cellClick: function (e, cell) {
        e.preventDefault();
        const rowInfo = cell._cell.row.data;
        setRedirect({ allow: true, id: rowInfo.id, type: 'image' }); //here we update state
      },
    },
    // { title: "View File", field: "viewFile", headerFilter: "input" , 
    //   formatter: (cell) => {
    //     const value = cell.getValue();
    //     if(value == 'View File'){
    //       const fileUrl = cell.getRow().getData().fileUrl;
    //       return `<a href="$" target="_blank" rel="noopener noreferrer"> View File </a>`;
    //     }else{
    //       return value;
    //     }
      
    //   }},
   
  ];

  return redirect.allow ? (
       redirect.type == "image" ? (
          // <Redirect push to={`/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}/view/${redirect.id}`}/>
          <Redirect push to={location.pathname+"/view/"+redirect?.id} />
        ) : (
          // <Redirect push to={`/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}/${redirect.id}`}/>
            <Redirect push to={location.pathname+"/"+redirect?.id} />
        )
    // <Redirect push to={location.pathname + "/" + redirect?.id} />
  ) : doApplicationData.status === "fetched" ? (
    
    <TabulatorTemplate
      moduleName={"DoApplication"}
      columns={columns}
      moduleData={parsedData}
      tabs={tabs}
      disableWidget={permission.add ? flipTrueFalse(permission.add) : true}
      handleRefetch={handleRefetch}
    />
  ) : doApplicationData.status === "fetching" ? (
    <div>Loading...</div>
  ) : (
    <div>DO Application is not available</div>
  );
}

function ApplicationContainer(props) {
  const permission = useUserPermission(36);

  return (
    <MainTemplate
      content={
        <Switch>
          {permission.add ? (
            <Route
              exact
              path="/:page/create"
              children={<DoApplicationCreate />}
            />
          ) : null}
          {permission.view ? (
            <Route exact path="/:page/:id" children={<DoApplicationInfo />} />
          ) : null}
          {permission.view ? (
            <Route exact path="/:page/view/:doid" children={<DoFilePreview />} />
          ) : null}
          {permission.view ? (
            <Route exact children={<DoApplication permission={permission} />} />
          ) : null}
         
        </Switch>
      }
    />
  );
}

export default ApplicationContainer;
